import { render, staticRenderFns } from "./detail_jsxx.vue?vue&type=template&id=02114509&scoped=true&"
import script from "./detail_jsxx.vue?vue&type=script&lang=js&"
export * from "./detail_jsxx.vue?vue&type=script&lang=js&"
import style0 from "./detail_jsxx.vue?vue&type=style&index=0&id=02114509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02114509",
  null
  
)

export default component.exports